module.exports = __webpack_public_path__ + "components/Map/graphics/tree-cluster-pin.70dfc429f8d811c56986659f93e9a152.png";